import lang from "@/views/modules/Users/language/en";

let searchFieldsDef = {
    'first_name': {
        label: lang.LBL_FIRST_NAME,
    },
    'last_name': {
        label: lang.LBL_LAST_NAME,
    },
    'email': {
        label: lang.LBL_USER_EMAIL,
    },
    'role_id': {
        label: lang.LBL_ROLE,
        type: 'selectcomponent',
        route: 'user-roles',
        moduleName: 'UserRoles',
        name: 'user_role_name',
        id: 'user_role_id'

    },
    'status': {
        label: lang.LBL_USER_STATUS,
        type: 'checkbox',
        field_infos: 'status',
    },
};
export default { searchFieldsDef }